import { Organisation } from 'openapi';

/**
 * Get the default currency or fallback to EUR
 */
export const getDefaultCurrency = (selectedOrganizationDetails: Organisation | undefined): string => {
  return selectedOrganizationDetails?.currency ?? 'EUR';
};
